module.exports = __webpack_public_path__ + "media/img/vca/step1-a0d197b9b33cc3ec5acc8ae4c9f8213e.png";